(function () {
  var TRY_HOST = 'try.cleanskinclub.com';

  function forwardQueryToTryLinks() {
    var qs = window.location.search;
    if (!qs || qs.length < 2) return;
    var params = qs.slice(1);
    document.querySelectorAll('a[href*="' + TRY_HOST + '"]').forEach(function (anchor) {
      try {
        var url = new URL(anchor.href);
        params.split('&').forEach(function (kv) {
          if (!kv) return;
          var eq = kv.indexOf('=');
          var key = eq > -1 ? kv.slice(0, eq) : kv;
          var val = eq > -1 ? kv.slice(eq + 1) : '';
          if (key && !url.searchParams.has(key)) {
            url.searchParams.set(key, decodeURIComponent(val.replace(/\+/g, ' ')));
          }
        });
        anchor.href = url.toString();
      } catch (err) {}
    });
  }

  function injectDebugLink() {
    if (window.location.search.indexOf('attribution_debug=1') === -1) return;
    if (document.querySelector('[data-try-attribution-debug]')) return;
    var link = document.createElement('a');
    link.setAttribute('data-try-attribution-debug', '');
    link.href = 'https://' + TRY_HOST + '/bundle/b07';
    link.textContent = 'Debug: open b07 (hover to verify query params)';
    link.style.cssText =
      'position:fixed;bottom:100px;left:12px;z-index:10001;padding:10px 14px;background:#003a66;color:#fff;font-size:13px;font-weight:600;border-radius:8px;box-shadow:0 4px 12px rgba(0,0,0,.2);';
    document.body.appendChild(link);
  }

  function run() {
    injectDebugLink();
    forwardQueryToTryLinks();
  }

  function init() {
    run();
    window.setTimeout(run, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof MutationObserver !== 'undefined') {
    var timer;
    new MutationObserver(function () {
      if (timer) return;
      timer = window.setTimeout(function () {
        timer = null;
        run();
      }, 100);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
